/**
 * Checks whether the given location hash are different.
 *
 * @see isDifferentHashLocationUtil
 *
 * @param  {Object} location1
 * @param  {Object} location2
 * @returns {boolean}
 */
export default function isDifferentHashLocationUtil (location1, location2) {
  return (
    location1 &&
    location2 &&
    location1?.hash !== location2?.hash
  )
}
